/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RelationshipType } from './RelationshipType';
import {
    RelationshipTypeFromJSON,
    RelationshipTypeFromJSONTyped,
    RelationshipTypeToJSON,
    RelationshipTypeToJSONTyped,
} from './RelationshipType';

/**
 * 
 * @export
 * @interface AssetDependantResponse
 */
export interface AssetDependantResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetDependantResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDependantResponse
     */
    firstName: string | null;
    /**
     * 
     * @type {RelationshipType}
     * @memberof AssetDependantResponse
     */
    relationship: RelationshipType | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetDependantResponse
     */
    birthDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantResponse
     */
    livesInHousehold: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantResponse
     */
    isJointlyLiable: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantResponse
     */
    isEntitledToMaintenance: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantResponse
     */
    hasToPayAlimony: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetDependantResponse
     */
    monthlyAlimonyAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantResponse
     */
    paidFullLastMonth: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantResponse
     */
    fullyGarnishedLastMonth: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetDependantResponse
     */
    note: string | null;
}



/**
 * Check if a given object implements the AssetDependantResponse interface.
 */
export function instanceOfAssetDependantResponse(value: object): value is AssetDependantResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('relationship' in value) || value['relationship'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    if (!('livesInHousehold' in value) || value['livesInHousehold'] === undefined) return false;
    if (!('isJointlyLiable' in value) || value['isJointlyLiable'] === undefined) return false;
    if (!('isEntitledToMaintenance' in value) || value['isEntitledToMaintenance'] === undefined) return false;
    if (!('hasToPayAlimony' in value) || value['hasToPayAlimony'] === undefined) return false;
    if (!('monthlyAlimonyAmount' in value) || value['monthlyAlimonyAmount'] === undefined) return false;
    if (!('paidFullLastMonth' in value) || value['paidFullLastMonth'] === undefined) return false;
    if (!('fullyGarnishedLastMonth' in value) || value['fullyGarnishedLastMonth'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function AssetDependantResponseFromJSON(json: any): AssetDependantResponse {
    return AssetDependantResponseFromJSONTyped(json, false);
}

export function AssetDependantResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDependantResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['firstName'],
        'relationship': RelationshipTypeFromJSON(json['relationship']),
        'birthDate': (json['birthDate'] == null ? null : new Date(json['birthDate'])),
        'livesInHousehold': json['livesInHousehold'],
        'isJointlyLiable': json['isJointlyLiable'],
        'isEntitledToMaintenance': json['isEntitledToMaintenance'],
        'hasToPayAlimony': json['hasToPayAlimony'],
        'monthlyAlimonyAmount': json['monthlyAlimonyAmount'],
        'paidFullLastMonth': json['paidFullLastMonth'],
        'fullyGarnishedLastMonth': json['fullyGarnishedLastMonth'],
        'note': json['note'],
    };
}

export function AssetDependantResponseToJSON(json: any): AssetDependantResponse {
    return AssetDependantResponseToJSONTyped(json, false);
}

export function AssetDependantResponseToJSONTyped(value?: AssetDependantResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstName': value['firstName'],
        'relationship': RelationshipTypeToJSON(value['relationship']),
        'birthDate': value['birthDate'] == null ? value['birthDate'] : `${value['birthDate'].getFullYear()}-${String(value['birthDate'].getMonth()+1).padStart(2,'0')}-${String(value['birthDate'].getDate()).padStart(2,'0')}`,
        'livesInHousehold': value['livesInHousehold'],
        'isJointlyLiable': value['isJointlyLiable'],
        'isEntitledToMaintenance': value['isEntitledToMaintenance'],
        'hasToPayAlimony': value['hasToPayAlimony'],
        'monthlyAlimonyAmount': value['monthlyAlimonyAmount'],
        'paidFullLastMonth': value['paidFullLastMonth'],
        'fullyGarnishedLastMonth': value['fullyGarnishedLastMonth'],
        'note': value['note'],
    };
}

